import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import useAuthStore from '@/store/authStore';
import { EMangerLevel } from '@store/authStore';
import useUserStore from '@/store/userStore';
import { localMemory } from 'localmemory';
import { useUserInfo } from '@/service/useUserInfo';

/**
 * 权限路由拦截
 * @param to
 * @param from
 * @param next
 * @returns
 */
export const authRouter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const authStore = useAuthStore();

  let errStatus;
  if (authStore.routerPermissions === null) {
    const { getUserInfo, error } = useUserInfo();
    if (!localMemory.getItem('userToken')) {
      next({ path: '/login' });
      return false;
    }
    await getUserInfo();
    errStatus = error;
  }

  if (authStore.mangerLevel === EMangerLevel.admin) {
    // 超级管理员
    // next(true);
  } else {
    if (!authStore.routerPermissions) {
      // if (errStatus.value) {
      //   next({ path: '/login' });
      //   return true;
      // }
    }
    if (!authStore.routerPermissions?.includes?.(to.path)) {
      // 没有权限
      // ElMessage.error($p('你没有权限'));
      // next({ path: '/login' });
      // return true;
    }
    // next(true);
  }

  const userStore = useUserStore();
  const token = localMemory.getItem('userToken');
  if (!token) {
    userStore.logOut();
    return true;
  }
};
